module.exports = __webpack_public_path__ + "img/ioniq9-26.b9091837.png";